import styled from '@emotion/styled';
import React from 'react';
import RightArrow from '../../Icon/arrow-right-black.svg';

const StyledRightArrow = styled(RightArrow)({
    height: '24px',
    width: '24px',
});

const Arrow = ({ ...rest }) => {
    return <StyledRightArrow {...rest} />;
};

export default Arrow;
